export const PAGE_SIZE = 100;
export const MAX_DATE = '2099-12-31';
export const MIN_DATE = '1900-01-01';

export const KEYBOARD_KEYS = {
  ESCAPE: 'Escape',
  ENTER: 'Enter'
};
